import { Stack, Row, Col } from '@leroy-merlin-br/backyard-react-ui'

import { Skeleton } from 'lmcv/components/Skeleton'

const FormSkeleton = () => {
  return (
    <Stack spacing="mega">
      <Row>
        <Col size={{ giga: 6 }}>
          <Skeleton rounded width="100%" height="34px" />
        </Col>
        <Col size={{ giga: 6 }}>
          <Skeleton rounded width="100%" height="34px" />
        </Col>
      </Row>

      <Skeleton rounded width="100%" height="34px" />

      <Row>
        <Col size={{ giga: 6 }}>
          <Skeleton rounded width="100%" height="34px" />
        </Col>
        <Col size={{ giga: 6 }}>
          <Skeleton rounded width="100%" height="34px" />
        </Col>
      </Row>

      <Skeleton rounded width="100%" height="34px" />

      <Skeleton rounded width="100%" height="34px" />
    </Stack>
  )
}

export default FormSkeleton
